<template>
  <div class="ard-wrap">
    <modal name="addRace" class="ard-modal" @before-close="onClose" :adaptive="true" height="auto" width="90%" :maxWidth="620">
      <div class="ard-dialog">
        <div class="ard-dialog-header">
          <div class="ard-dialog-header-left">
            <span class="ard-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
                <path d="M12 5v14M5 12h14"/>
              </svg>
            </span>
            <div>
              <h2 class="ard-dialog-title">Add Race</h2>
              <p class="ard-dialog-sub">Attach this runner to a race and set the starting distance</p>
            </div>
          </div>
          <button class="ard-close-btn" type="button" title="Close" @click="$modal.hide('addRace')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div class="ard-dialog-body">
          <label class="ard-field">
            <span class="ard-label">Race Id</span>
            <input type="number" v-model="raceId" name="raceId" placeholder="Enter race id" class="ard-input">
          </label>
          <label class="ard-field">
            <span class="ard-label">Distance</span>
            <div class="ard-input-unit">
              <input type="number" v-model="newdistance" name="newdistance" placeholder="0.00" class="ard-input">
              <span class="ard-unit">Km</span>
            </div>
          </label>
          <p v-if="error" class="ard-error">Not a valid Race Id !</p>
        </div>
        <div class="ard-dialog-footer">
          <button class="ard-cancel-btn" type="button" @click="$modal.hide('addRace')">Cancel</button>
          <button class="ard-save-btn" type="button" v-on:click="Save(raceId,newdistance)">Save</button>
        </div>
      </div>
    </modal>  
  </div>
  
</template>

<script>
  import RunnersByRaceService from '../../../services/runnersByRace'
  import { db } from '../../../firebase'

  export default {
    name: 'add-race-data',
    data: () => ({
        raceId:'',
        newdistance:0,
        //finishDate: '',
        // newRunnerRaceResume: {
        //  	  distance:0.00,
        //     paceAVG:0.00,
        //     timeTotal:0,
        //     runner:{},
        //     raceResume: {
        //       id:''
        //     }
        // },
        error:false

    }),
    props:{
            race: {
                type:Object
            },
            show:false,
            runnerId:''
        },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
        onClose() {
                this.$emit('closed', true)
        },
        openEditModal() {
          this.raceId='',
          this.newdistance=0,
          this.error=false
          // this.newRunnerRaceResume= {
         	//   distance:0.00,
          //   paceAVG:0.00,
          //   timeTotal:0,
          //   runner:{},
          //   raceResume: {
          //     id:''
          //   }
          // },
          this.$modal.show('addRace')
          console.log("runnerid---",this.runnerId)         
          // this.newRunnerRaceResume.runner = {
          //   id:this.runnerId
          // }
          // this.newRunnerRaceResume.raceResume= {
          //   "id": this.race.runnerRaceResume.raceResume.id
          // }
          //  console.log("his.newRunnerRaceResume---",this.newRunnerRaceResume)

          // this.newRunnerRaceResume= {
         	//   distance:this.race.runnerRaceResume.distance,
          //   paceAVG:this.race.runnerRaceResume.paceAVG,
          //   timeTotal:this.race.runnerRaceResume.timeTotal,
          // }
        },
        async Save (raceId,distance) { 
        var raceInFb = await db.ref(`/${this.$fbDbEntry}/${raceId}`).once('value')

        if(raceInFb.val()==null){
          console.log("innn")
          this.error=true
          return
        }
        var raceResumeId =  raceInFb.val().raceResumeId
        console.log("---", raceInFb.val().raceResumeId )
          var data = {
              distance:parseFloat(distance)*1000,
              paceAVG:0,
              timeTotal:0,
              runner:{
                id:this.runnerId
              },
              raceResume: {
                id:raceResumeId
              }
          }
           console.log("data---",data)
            RunnersByRaceService.addRaceResume(data).then((response) => {
              this.error=false
              console.log("response---",response)
              this.$emit('saved', response.data)
              this.$modal.hide('addRace')
            },
            error =>{
              console.log("error---",error)
              this.error=true
            })
        }
    },
    created() {
    },
    
    watch: {
        show(oldVal, newVal) {
            if(this.show){
             this.openEditModal()
            }
        }
    }
  }
</script>
<style scoped>
.ard-dialog {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.ard-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem 1.75rem;
  border-bottom: 1px solid #f0f0f5;
}
.ard-dialog-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ard-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ard-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}
.ard-dialog-sub {
  font-size: 12px;
  color: #8a8a9a;
  margin: 4px 0 0;
}
.ard-close-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e8e8ed;
  background: #fff;
  color: #8a8a9a;
  cursor: pointer;
}
.ard-close-btn:hover {
  color: #c0392b;
  border-color: #ffd6d6;
}
.ard-dialog-body {
  padding: 1.5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.ard-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.ard-label {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a2e;
}
.ard-input-unit {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.ard-input {
  height: 40px;
  width: 100%;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  background: #fafafa;
  color: #1a1a2e;
  font-size: 14px;
  padding: 0 0.75rem;
}
.ard-input:focus {
  outline: none;
  border-color: #5b4fcf;
  box-shadow: 0 0 0 3px rgba(91, 79, 207, 0.12);
}
.ard-unit {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a2e;
}
.ard-error {
  font-size: 12px;
  color: #c0392b;
  margin: 0;
}
.ard-dialog-footer {
  border-top: 1px solid #f0f0f5;
  padding: 1rem 1.75rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.ard-cancel-btn,
.ard-save-btn {
  height: 36px;
  border-radius: 8px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.ard-cancel-btn {
  border: 1px solid #e0e0ea;
  background: #fff;
  color: #5b4fcf;
}
.ard-save-btn {
  border: none;
  background: #5b4fcf;
  color: #fff;
}
.ard-save-btn:hover {
  background: #4338ca;
}
</style>



// WEBPACK FOOTER //
// AddRaceData.vue?105e4531